export default __webpack_public_path__ + "static/media/holly_on.7d9edb96.png";